import Auth from '../auth/Auth';
import Profile from '../models/Profile';
import { WebClient } from './WebClient'

class ApiProfile extends WebClient {
    async getProfiles(customerId: number): Promise<Profile[]> {
        const url = `/profile/${customerId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async deleteProfile(profileId: number): Promise<boolean> {
        const url = `/profile/${profileId}`;

        return this.delete(url, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }

    async undeleteProfile(profileId: number): Promise<boolean> {
        const url = `/profile/undel/${profileId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }
}

export default new ApiProfile();
